/* src/app/modules/ct-status/components/cts-gantry-startup-pane/cts-gantry-startup-pane.component.scss */
:host {
  display: block;
}
.card-header {
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  align-items: center;
}
.card-header sh-text:first-of-type {
  font-size: 1rem;
  font-weight: 700;
  line-height: 2.5rem;
}
.card-header sh-text {
  width: max-content;
}
.cts-startup-details-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "action-grid" "empty-row-10" "startup-head-grid" "startup-grid" "empty-row-16" "legends";
}
.common-grid {
  display: grid;
  grid-template-columns: 9.25rem 0.5rem minmax(31.3125rem, 1fr) 3.75rem minmax(31.3125rem, 1fr);
  align-items: center;
  padding-right: 0.75rem;
}
.step-labels {
  overflow: hidden;
  scrollbar-gutter: stable;
}
.common-grid--show-log {
  grid-template-columns: 9.25rem 0.5rem minmax(31.3125rem, 1fr);
}
.cts-action-grid {
  grid-area: action-grid;
}
.cts-startup-head-grid {
  grid-area: startup-head-grid;
}
.cts-startup-grid {
  grid-area: startup-grid;
  max-height: 29.75rem;
  overflow: hidden auto;
}
.font-weight-700 {
  font-weight: 700;
}
.empty-row-10 {
  grid-area: empty-row-10;
  height: 0.625rem;
  padding-right: 0.75rem;
}
.empty-row-16 {
  grid-area: empty-row-16;
  height: 1rem;
  padding-right: 0.75rem;
}
.legends {
  grid-area: legends;
  padding-right: 0.75rem;
}
/*# sourceMappingURL=cts-gantry-startup-pane.component.css.map */
